import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import {BoxProps, withStyles} from '@material-ui/core';

import {getDirectionStyles} from '../../utils/ThemeUtils';

export const FortnigtContainer = styled.section`
    margin-top: ${p => p.theme.muiTheme.spacing(10)}px;
`;

export const WidgetsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${p => p.theme.muiTheme.spacing(10)}px;

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        margin-top: ${p => p.theme.muiTheme.spacing(11)}px;
    }
    ${p => p.theme.muiTheme.breakpoints.up('flg')} {
        flex-direction: row;
        margin-top: ${p => p.theme.muiTheme.spacing(12)}px;
    }
    ${p => p.theme.muiTheme.breakpoints.up('xl')} {
        margin-top: ${p => p.theme.muiTheme.spacing(15)}px;
    }
`;

export const GameXpWidgetsContainer = styled.div`
    margin-top: ${p => p.theme.muiTheme.spacing(10)}px;

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        margin-top: ${p => p.theme.muiTheme.spacing(11)}px;
    }
    ${p => p.theme.muiTheme.breakpoints.up('flg')} {
        margin-top: ${p => p.theme.muiTheme.spacing(12)}px;
    }
    ${p => p.theme.muiTheme.breakpoints.up('xl')} {
        margin-top: ${p => p.theme.muiTheme.spacing(15)}px;
    }
`;

export const GameXpSidebarContainer = styled.div`
    grid-area: game-xp-sidebar;

    ${p => p.theme.muiTheme.breakpoints.up('fsm')} {
        display: flex;
        margin-top: ${p => p.theme.muiTheme.spacing(10)}px;
    }
    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        margin-top: ${p => p.theme.muiTheme.spacing(5)}px;
        padding: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 0, 0, 7),
                p.theme.muiTheme.spacing(0, 7, 0, 0)
            )};
    }
    ${p => p.theme.muiTheme.breakpoints.up('lg')} {
        margin-top: ${p => p.theme.muiTheme.spacing(12)}px;
        display: block;
    }
    ${p => p.theme.muiTheme.breakpoints.up('flg')} {
        padding: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 0, 0, 10),
                p.theme.muiTheme.spacing(0, 10, 0, 0)
            )};
    }
`;

export const ChartContainer = styled.div`
    width: 100%;

    & > *:not(:first-child) {
        margin-top: ${p => p.theme.muiTheme.spacing(9)}px;
    }
`;

export const ActivationsPieChartContainer = styled.div`
    width: 100%;
    padding-bottom: 100%;
    margin-top: 10px;
    position: relative;

    ${p => p.theme.muiTheme.breakpoints.up('fsm')} {
        min-width: 45%;
        width: 45%;
        padding-bottom: 45%;
        margin-top: 0;
        align-self: center;
        margin: ${p => getDirectionStyles(p.theme.muiTheme.direction)('0 3% 0 0', '0 0 0 3%')};
    }
    ${p => p.theme.muiTheme.breakpoints.up('lg')} {
        width: 100%;
        padding-bottom: 100%;
    }

    & > div,
    & > div > div {
        position: absolute;
        width: 100%;
        height: 100%;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        flex-direction: column;
    }
`;

export const ActionContainer = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        marginTop: theme.spacing(11),

        [theme.breakpoints.up('fmd')]: {
            flexWrap: 'nowrap'
        }
    }
}))(Box);

export const DatePickerWrapper = styled.div`
    margin: 0;

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        margin: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 3, 0, 0),
                p.theme.muiTheme.spacing(0, 0, 0, 3)
            )};
    }
`;

export const ControlWrapper = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 2,
        alignItems: 'flex-end',

        [theme.breakpoints.up('fmd')]: {
            flexWrap: 'nowrap'
        }
    }
}))(Box);

export const SelectWrapper = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        minWidth: 316,
        width: '100%',
        flexGrow: 1,

        [theme.breakpoints.up('fmd')]: {
            maxWidth: '316px'
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '612px'
        }
    }
}))(Box);

export const InsightsSpacer = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        [theme.breakpoints.up('fmd')]: {
            width: theme.spacing(8)
        },
        [theme.breakpoints.up('lg')]: {
            width: theme.spacing(3)
        }
    }
}))(Box);

export const GameXpGrid = styled.div`
    ${p => p.theme.muiTheme.breakpoints.up('lg')} {
        display: grid;
        grid-gap: 0;
        grid-template-columns: 70% 30%;
        grid-template-areas:
            'game-xp-header .'
            'game-xp-footer game-xp-sidebar';
        width: 100%;
    }
`;

export const GameXpHeader = styled.div`
    grid-area: game-xp-header;
`;
